import { useTranslation } from "../hooks/useTranslation";

// Canonical English names of the categories seeded for every new workspace
// (mirrors Category::PREBUILT_CATEGORIES on the backend). The stored `name`
// stays English — it is used for default-category detection ("New") and for
// API calls — so we only translate the DISPLAYED label based on the viewer's
// chosen language. User-created categories (and renamed prebuilts) are not in
// this set and render verbatim.
export const PREBUILT_CATEGORY_NAMES = [
  "New",
  "Mishloach Monos",
  "Matzah",
  "Cheesecake",
  "Honey cake",
  "Challah",
  "Future",
  "Nonfunctional address",
  "No contact info",
  "Left Town",
] as const;

const PREBUILT_SET = new Set<string>(PREBUILT_CATEGORY_NAMES);

/**
 * Returns a function that maps a category name to its localized display label.
 * Prebuilt (seeded) categories are translated; everything else is returned
 * unchanged. Reacts to language changes because it reads the live i18n instance.
 */
export const useCategoryName = () => {
  const { p } = useTranslation("prebuilt_categories");
  return (name?: string | null): string => {
    if (!name) return name ?? "";
    return PREBUILT_SET.has(name) ? p(name, { defaultValue: name }) : name;
  };
};
